module.exports = __webpack_public_path__ + "img/1F1F7-1F1EA.b053e265.svg";